export default __webpack_public_path__ + "static/media/051-infinity.5ec326c5.svg";